import React from 'react'
import { useSelector } from 'react-redux'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { CustomTableCell } from './CustomTableCell'
import { checkNullorEmptyObj, createVehicleData } from '../../../../lib/util'

const tableStyle = {
  minWidth: 350,
}

export default function VehicleTypeTable() {
  const { selectedAttack } = useSelector(state => state)

  if (checkNullorEmptyObj(selectedAttack) || !selectedAttack.original_id) {
    return <div>Please select a re-calculated attack</div>
  } else {
    const data = createVehicleData(selectedAttack)
    const units = selectedAttack.units

    return (
      <TableContainer component={Paper}>
        <Table sx={tableStyle} size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">Vehicle Type</TableCell>
              <TableCell align="center">{`End Speed (${units.speedUnits})`}</TableCell>
              <TableCell align="center">Energy (kJ)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => (
              <TableRow key={i}>
                <CustomTableCell {...{ row, name: 'vehicle' }} />
                <CustomTableCell {...{ row, name: 'end_speed' }} />
                <CustomTableCell {...{ row, name: 'energy' }} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }
}
